import type { FC } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { IconContext } from './IconContext';
import { useIcons } from '../hooks/context/useIcons';
import { PdfContext } from './PdfContext';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const AppContextProvider: FC = ({ children }) => {
  const icons = useIcons();

  return (
    <QueryClientProvider client={queryClient}>
      <IconContext.Provider value={icons}>
        <PdfContext.Provider value={{ isPdf: false }}>
          {children}
        </PdfContext.Provider>
      </IconContext.Provider>

      <ReactQueryDevtools toggleButtonProps={{ style: { margin: '0' } }}/>
    </QueryClientProvider>
  );
};
